import { ListDisplayContainer } from "./stylesListDisplay";
import Accordion from 'react-bootstrap/Accordion';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from "react-bootstrap";
import IList from "../../types/IList";
import IProduct from "../../types/IProduct";
import CalculatorModal from "../Calculator/CalculatorModal";
import { useEffect, useState } from "react";
import { updateCheckbox, handleDeleteProduct, dateConverter, getTotal, saveListForLater } from "../../service/api";
import { getFormatedPrice } from "../../service/utils";
import Modal from 'react-bootstrap/Modal';
import AddNewProductToList from "../AddNewProductToList/AddNewProductToList";
import { v4 as uuidv4 } from 'uuid';
import { ButtonContainer } from "../PickList/stylesPickList";
import { useForm } from 'react-hook-form';
import { updateProduct } from '../../service/api';
import { AddNewProductContainer } from '../AddNewProductToList/stylesAddNewProduct';
import { loggedUser } from "../../state/atom";
import { useRecoilValue } from "recoil";


export default function ListDisplay(props: { completed: any, createdAt: any, items: any[], title: any, id: string }) {
    
    const user = useRecoilValue(loggedUser);
    
    const editItemModel: IProduct = {
        name: "",
        price: 0,
        unities: 0,
        quantities: 0,
        checked: false
    };
    const [currentEditItem, setCurrentEditItem] = useState(editItemModel);
   
    let array: IProduct[] = []

    function getCheckedItems(list: IProduct[]) {
        let markedItems = list.forEach((item: IProduct) => {
            if (item.checked) {
                array.push(item);
            }             
            return;
        })
        return markedItems;
    }
    
    if (props.items.length > 0) getCheckedItems(props.items);

    function handleUnmarkedItemsList() {
        let unmarkedItems: IProduct[] = []
        props.items.forEach((item: IProduct) => {
            if(item.checked === false) unmarkedItems.push(item);
        })
        saveListForLater(unmarkedItems, user.uid);
        alert('Itens salvos na lista "Salvo para a próxima compra"');
    }

    //React Bootstrap Modal
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => {
        setShowEdit(false);
        reset();
    }
    const handleShowEdit = () => setShowEdit(true);

    // React Hook Form
    const { register, handleSubmit, reset } = useForm();
    const onSubmitEdit = (data: any) => {
        saveEditProduct(data);
    }

    function saveEditProduct(data: { name: string, price: string, quantities: string, unities: string }) {
        const editProduct: IProduct = {
            name: (data.name !== "" && data.unities !== " " ? data.name : currentEditItem.name),
            price: (data.price !== "" && data.unities !== " " ? Number(data.price) : currentEditItem.price),
            quantities: (data.quantities !== "" && data.unities !== " " ? Number(data.quantities) : currentEditItem.quantities),
            unities: (data.unities !== "" && data.unities !== " " ? Number(data.unities) : currentEditItem.unities),
            checked: false
        };
        updateProduct(props.id, currentEditItem, editProduct);
        handleCloseEdit();
        reset();
        alert("Produto editado com sucesso");
    }

    return (
        <>
            <ListDisplayContainer>
                <h3>Lista: {props.title} <br /> <span>Criada em: {dateConverter(props.createdAt?.toDate())}</span></h3>
                <h4>Itens marcados: {(array.length > 0 && array.length) || 0} / {props.items.length}</h4>
                <div className="save-for-later">
                    <Button className="save-for-later" variant="light" onClick={() => handleUnmarkedItemsList()}>Salvar para mais tarde</Button>
                </div>
                <Accordion defaultActiveKey="0" >
                    {props.items[0] !== undefined && props.items.map((item: IProduct) => {
                        return (
                            <>
                                <Accordion.Item eventKey={item.name} key={uuidv4()} >
                                    <Accordion.Header className="product-header">
                                        <input className="check-product" type="checkbox" name={item.name} id={item.name} checked={item.checked} onChange={() => updateCheckbox(!item.checked, props.id, item)} />
                                        <p>{item.name}</p>
                                        <p>{item.price ? getFormatedPrice(item.price, item.unities) : "-----"}</p>
                                    </Accordion.Header>
                                    <Accordion.Body className='d-flex flex-row'>

                                        <ul className="m-2">
                                            <li>Nome: {item.name} </li>
                                            <li>Preço: R$ {item.price?.toString()} </li>
                                            <li>Quantidade g / ml: {item.quantities?.toString()} </li>
                                            <li>Unidade: {item.unities?.toString()} </li>
                                            <li>Preço por g / ml: {item.price && item.quantities ? (Number(item.price) / Number(item.quantities)).toFixed(5) : "~~~"}</li>
                                        </ul>
                                        <div className="m-2">

                                            <Button variant="danger" className="m-2" onClick={() => handleDeleteProduct(props.id, item)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
                                                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                                </svg>
                                            </Button>

                                            <Button variant="success" onClick={() => {
                                                setCurrentEditItem(item);
                                                handleShowEdit();
                                                }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                    <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                                                </svg>
                                            </Button>

                                        </div>


                                    </Accordion.Body>
                                </Accordion.Item>

                                <CalculatorModal />
                            </>
                        );
                    })}
                </Accordion>
                <Modal
                    show={showEdit}
                    onHide={handleCloseEdit}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Editar produto</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AddNewProductContainer>
                            <form onSubmit={handleSubmit(onSubmitEdit)}>
                                <h4 >Nome atual: <span>{currentEditItem.name}</span></h4>
                                <input placeholder='Insira o nome do produto'  {...register("name")} />
                                <h4 >Preço atual: {currentEditItem.price}</h4>
                                <input placeholder='Insira o preço do produto' type="number" step="any"{...register("price")}  />
                                <h4>Quantidade g/ml atual: {currentEditItem.quantities}</h4>
                                <input placeholder='Insira a quantidade em g ou ml' type="number" {...register("quantities")}  />
                                <h4>Unidade{"(s)"} atual : {currentEditItem.unities}</h4>
                                <input placeholder='Insira o número de unidades' type="number" {...register("unities")} />
                                <br></br>
                                <Button type="submit" variant="primary" >Salvar alterações no produto</Button>
                                <Button variant="danger" onClick={handleCloseEdit}>
                                    Fechar
                                </Button>
                            </form>
                        </AddNewProductContainer>
                    </Modal.Body>
                    
                </Modal>

                <AddNewProductToList id={props.id} />
                <h4>Itens marcados: {(array.length > 0 && array.length) || 0} / {props.items.length}</h4>
                <div className="save-for-later" >
                    <Button onClick={() => handleUnmarkedItemsList()} variant="light">Salvar para mais tarde</Button>
                </div>

                <h3>Total: R$  {props.items.length > 0 && getTotal(props.items)}</h3>
            </ListDisplayContainer>
        </>
    );
}

